var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 61,
    viewBox: "0 0 42 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5974 1.09995C8.7974 2.19995 0.8974 9.89995 0.0973995 19.4999C-0.5026 26.4999 2.5974 32.9 7.5974 37C9.0974 38.2 9.9974 40 9.9974 41.9V42C9.9974 44.7999 12.2974 47.0999 15.1974 47.0999H26.7974C29.6974 47.0999 31.9974 44.7999 31.9974 42V41.9C31.9974 40 32.8974 38.2 34.3974 37C38.9974 33.2 41.9974 27.5999 41.9974 21.2999C41.9974 9.29995 31.2974 -0.200051 18.5974 1.09995Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 53H12C10.9 53 10 53.9 10 55C10 58.3 12.7 61 16 61H26C29.3 61 32 58.3 32 55C32 53.9 31.1 53 30 53Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.716e704849d13947bef19239f7d83fdf.svg";
export { ForwardRef as ReactComponent };